import Layout from "antd/lib/layout";
import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import NavMenu from "./components/NavMenu";
import UserMenu from "./components/UserMenu";
import "./Root.css";
import Connections from "./views/Connections";

export default class Root extends React.Component {
    render() {
        return (
            <Layout className="c-Root">
                <Layout.Header className="header">
                    <NavMenu />
                    <UserMenu />
                </Layout.Header>
                <Layout.Content className="content">
                    <Switch>
                        <Route
                            exact={true}
                            path="/"
                            render={() => <Redirect to="/connections" />}
                        />
                        <Route
                            component={Connections}
                            exact={true}
                            path="/connections"
                        />
                    </Switch>
                </Layout.Content>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Root.js